<template>

    <div class="product_detail">
        <div class="box" v-if="isReload==false && Object.keys(product_info).length!==0">
            <!-- 商品图片与操作 -->
            <div class="product_operating">

                <div class="box_operation">
                    <!-- 商品图片 -->
                    <div class="show_image">

                        <el-carousel :interval="5000" arrow="always" :style="{display:'none',marginBottom:'100px'}">
                            <el-carousel-item v-for="src in this.product_info.product_img_url" :key="src">
                                <el-image fit="scale-down" :src="src"></el-image>
                            </el-carousel-item>
                        </el-carousel>

                        <el-image
                                fit="scale-down"
                                style="width:100%;height:auto;"
                                :src="bigImage"
                        >
                            <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                                <div class="el_image">
                                    <span class="dot" v-loading="true" element-loading-spinner="el-icon-loading"
                                          style="font-size:20px"></span>
                                </div>
                            </div>
                        </el-image>
                    </div>
                </div>

                <ul :style="{padding:'10px 16px'}">
                    <li :style="{padding:'2px 0'}">{{product_info.product_name}}</li>
                    <li :style="{fontSize:'90%',color:'#777',padding:'2px 0'}">{{product_info.product_class_name}}</li>
                    <li :style="{padding:'2px 0'}">
                        <span :style="{color:'#f41200'}">￥&nbsp;<i>{{product_info.unit_price}}</i></span>
                    </li>
                </ul>

            </div>
            <!-- 商品详细信息-->
            <div class="product_info">
                <div><h3>详细信息</h3></div>
                <div v-if="( product_info.product_img_url !== undefined && product_info.product_img_url.length != 0)" class="share-form" style="width: 100%; background: white">
                    <el-form label-position="top" :rules="rules" ref="ruleForm1" label-width="80px" :model="ruleForm1">
                        <el-form-item label="您的姓名" prop="name">
                            <el-input v-model="ruleForm1.name" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="您的手机号" prop="phone">
                            <el-input v-model.number="ruleForm1.phone" placeholder="请输入"></el-input>
                        </el-form-item>
<!--                        <el-form-item label="合作意向(单选)" prop="resource">-->
<!--                            <el-radio-group v-model="ruleForm1.resource">-->
<!--                                <el-radio class="q-mt-md" label="有意向"></el-radio>-->
<!--                                <el-radio class="q-mt-md" label="50%意向"></el-radio>-->
<!--                                <el-radio class="q-mt-md" label="80%意向"></el-radio>-->
<!--                                &lt;!&ndash;                            <el-radio  class="q-mt-md" label="半年后装修"></el-radio>&ndash;&gt;-->
<!--                                &lt;!&ndash;                            <el-radio class="q-mt-md" label="已装修(无法使用五恒全空气系统)"></el-radio>&ndash;&gt;-->
<!--                            </el-radio-group>-->
<!--                        </el-form-item>-->
                        <div class="border-info">
                            <div class="row items-start justify-start no-wrap">
                                <div style="width: 25px;height: 25px;">
                                    <el-image :src="src.src_custom" style="width: 25px;height: 25px;"></el-image>
                                </div>
                                <div style="padding-top: 2px;">公司：{{share_custom_info.custom_name}}</div>
                            </div>
                            <!--                        <div class="row items-center" v-if="share_custom_info.custom_address"><el-image :src="src.address" style="width: 25px;height: 25px;"></el-image>地址：{{share_custom_info.custom_address}}</div>-->
                            <div class="row items-start justify-start no-wrap" v-if="share_custom_info.custom_address">
                                <div style="width: 25px;height: 25px;">
                                    <el-image :src="src.address" style="width: 25px;height: 25px;"></el-image>
                                </div>
                                <div style="padding-top: 2px;">地址：{{share_custom_info.custom_address}}</div>
                            </div>
                            <div class="row items-start justify-start no-wrap">
                                <div style="width: 25px;height: 25px;">
                                    <el-image :src="src.share_phone" style="width: 25px;height: 25px;"></el-image>
                                </div>
                                <div style="padding-top: 2px;">顾问：{{share_custom_info.share_nickname}} {{share_custom_info.share_phone}}</div>
                            </div>
                        </div>
                    </el-form>
                    <div class="text-subtitle2" style="color: #666666">
                        <div>提交报名即视为已阅读并同意<i class="title-i" @click="showAlertAction">《隐私政策》</i></div>
                    </div>
                    <el-button
                            style="width: 100%;height: 76px; margin-top: 10px;background-color: #17512b;color: white;font-size: 17px;font-weight:bold"
                            @click="submitForm1('ruleForm1')"><span>能传承三代的暖通系统 </span>
                        <br>
                        <div style="height: 6px;"></div>
                        <span>邀请你会话(提交)</span>
                    </el-button>

                </div>
                <ul class="img_list">
                    <li v-for="(item,index) in product_info.product_describe_img" :key="'B'+index">
                        <el-image
                                lazy
                                fit="cover"
                                style="width:100%;min-height:100px;"
                                :src="item"
                        >
                            <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                                <div class="el_image">
                                    <span class="dot" v-loading="true" element-loading-spinner="el-icon-loading"
                                          style="font-size:26px"></span>
                                </div>
                            </div>
                            <div slot="error" class="image-slot" style="width:100%;height:100%;">
                                <div class="el_image">
                                    <el-image fit="cover" :src="src.src_err"
                                              style="width:200px;height:200px;"></el-image>
                                </div>
                            </div>
                        </el-image>
                    </li>
                    <li v-for="(item,index) in htmlstr" :key="'C'+index">
                        <el-image
                                lazy
                                fit="cover"
                                style="width:100%;min-height:100px;"
                                :src="item"
                        >
                            <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                                <div class="el_image">
                                    <span class="dot" v-loading="true" element-loading-spinner="el-icon-loading"
                                          style="font-size:26px"></span>
                                </div>
                            </div>
                            <div slot="error" class="image-slot" style="width:100%;height:100%;">
                                <div class="el_image">
                                    <el-image fit="cover" :src="src.src_err"
                                              style="width:200px;height:200px;"></el-image>
                                </div>
                            </div>
                        </el-image>
                    </li>
                </ul>
                <div class="share-form" v-if="(htmlstr!==undefined && htmlstr.length !==0)" style="width: 100%; background: white">
                    <el-form label-position="top" :rules="rules" ref="ruleForm" label-width="80px" :model="ruleForm">
                        <el-form-item label="您的姓名" prop="name">
                            <el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="您的手机号" prop="phone">
                            <el-input v-model.number="ruleForm.phone" placeholder="请输入"></el-input>
                        </el-form-item>
                        <!--                        <el-form-item label="合作意向(单选)" prop="resource">-->
                        <!--                            <el-radio-group v-model="ruleForm1.resource">-->
                        <!--                                <el-radio class="q-mt-md" label="有意向"></el-radio>-->
                        <!--                                <el-radio class="q-mt-md" label="50%意向"></el-radio>-->
                        <!--                                <el-radio class="q-mt-md" label="80%意向"></el-radio>-->
                        <!--                                &lt;!&ndash;                            <el-radio  class="q-mt-md" label="半年后装修"></el-radio>&ndash;&gt;-->
                        <!--                                &lt;!&ndash;                            <el-radio class="q-mt-md" label="已装修(无法使用五恒全空气系统)"></el-radio>&ndash;&gt;-->
                        <!--                            </el-radio-group>-->
                        <!--                        </el-form-item>-->
<!--                        <div class="border-info">-->
<!--                            <div class="row items-center">-->
<!--                                <el-image :src="src.src_custom" style="width: 25px;height: 25px;"></el-image>-->
<!--                                公司：{{share_custom_info.custom_name}}-->
<!--                            </div>-->
<!--                            &lt;!&ndash;                        <div class="row items-center" v-if="share_custom_info.custom_address"><el-image :src="src.address" style="width: 25px;height: 25px;"></el-image>地址：{{share_custom_info.custom_address}}</div>&ndash;&gt;-->
<!--                            <div class="row items-start justify-start no-wrap" v-if="share_custom_info.custom_address">-->
<!--                                <div style="width: 25px;height: 25px;">-->
<!--                                    <el-image :src="src.address" style="width: 25px;height: 25px;"></el-image>-->
<!--                                </div>-->
<!--                                <div style="padding-top: 2px;">地址：{{share_custom_info.custom_address}}</div>-->
<!--                            </div>-->
<!--                            <div class="row items-center">-->
<!--                                <el-image :src="src.share_phone" style="width: 25px;height: 25px;"></el-image>-->
<!--                                顾问：{{share_custom_info.share_nickname}} {{share_custom_info.share_phone}}-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="border-info">
                            <div class="row items-start justify-start no-wrap">
                                <div style="width: 25px;height: 25px;">
                                    <el-image :src="src.src_custom" style="width: 25px;height: 25px;"></el-image>
                                </div>
                                <div style="padding-top: 2px;">公司：{{share_custom_info.custom_name}}</div>
                            </div>
                            <!--                        <div class="row items-center" v-if="share_custom_info.custom_address"><el-image :src="src.address" style="width: 25px;height: 25px;"></el-image>地址：{{share_custom_info.custom_address}}</div>-->
                            <div class="row items-start justify-start no-wrap" v-if="share_custom_info.custom_address">
                                <div style="width: 25px;height: 25px;">
                                    <el-image :src="src.address" style="width: 25px;height: 25px;"></el-image>
                                </div>
                                <div style="padding-top: 2px;">地址：{{share_custom_info.custom_address}}</div>
                            </div>
                            <div class="row items-start justify-start no-wrap">
                                <div style="width: 25px;height: 25px;">
                                    <el-image :src="src.share_phone" style="width: 25px;height: 25px;"></el-image>
                                </div>
                                <div style="padding-top: 2px;">顾问：{{share_custom_info.share_nickname}} {{share_custom_info.share_phone}}</div>
                            </div>
                        </div>
                    </el-form>
                    <div class="text-subtitle2" style="color: #666666">
                        <div>提交报名即视为已阅读并同意<i class="title-i" @click="showAlertAction">《隐私政策》</i></div>
                    </div>
                    <el-button
                            style="width: 100%;height: 76px; margin-top: 10px;background-color: #17512b;color: white;font-size: 17px;font-weight:bold"
                            @click="submitForm('ruleForm')">
                        <span>能传承三代的暖通系统 </span><br>
                        <div style="height: 6px;"></div>
                        <span class="q-mt-md">邀请你会话(提交)</span>
                    </el-button>

                </div>
            </div>
        </div>

        <!-- 数据加载 -->
        <div v-if="isReload" style="width:1200px;height:600px;background:transparent;margin:0 auto;" class="el_image">
            <div v-loading="true"></div>
            <div style="color:#409eff;font-size:14px;margin:100px 0 0 -14px;">数据加载中</div>
        </div>
        <!-- 无数据 -->
<!--        <div v-if="(isReload==false && Object.keys(product_info).length==0) || (( product_info.product_describe_img!==undefined && product_info.product_describe_img.length===0) && (htmlstr!==undefined && htmlstr.length===0))"-->
<!--             style="width:100%;height:600px;background:transparent;margin:0 auto;" class="el_image">-->
<!--            <el-image-->
<!--                    fit="cover"-->
<!--                    style="width:100%;height:600px;"-->
<!--                    :src="src.src_null"-->
<!--            >-->
<!--                <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">-->
<!--                    <div class="el_image">-->
<!--                        <span class="dot" v-loading="true" element-loading-spinner="el-icon-loading"-->
<!--                              style="font-size:20px"></span>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div slot="error" class="image-slot" style="width:100%;height:100%;">-->
<!--                    <div class="el_image">-->
<!--                        <el-image fit="cover" :src="src.src_err" style="width:100px;height:100px;"></el-image>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </el-image>-->
<!--        </div>-->
        <el-dialog
                title="隐私政策"
                :visible.sync="show_alert"
                width="80%"
                :before-close="handleClose">

            <div style="height: 200px;overflow:auto">

                <span style="text-indent:2em;display:block;">上海昱熙科技有限公司及其关联公司（以下简称“我们”）非常重视用户的隐私和个人信息保护，我们致力保护您的隐私和个人信息安全。您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。我们希望通过《隐私保护政策》（以下简称“本隐私保护政策）向您说明在您使用我们的产品与/或服务时，我们如何收集、使用、保存、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。我们使用这些信息的最终目的是支持和强化我们与您的关系，在任何情况下，我们都不会出售您的个人信息。</span>
                <span style="text-indent:2em;display:block;">请您认真阅读并充分理解本隐私保护政策，如您同意我们的政策内容，请同意并继续使用我们的产品与/或服务。我们会不断完善技术和安全管理，保护您的个人信息。</span>
                <h6>1、个人信息概念</h6>
                <span style="text-indent:2em;display:block;">个人信息即识别个人身份的资讯，如姓名、通讯地址、电子邮件地址、年龄组别等。我们只会在您自愿的情况下收集您的这些个人信息。</span>
                <span style="text-indent:2em;display:block;">若您选择向我们提供个人信息，我们保证只会在维护您与我们的关系的情况下使用这些信息。我们非常重视您对我们的信赖，因此绝不会向他人出售、出租或泄露您的个人信息。</span>
                <h6>2、收集个人信息的原因</h6>
                <span style="text-indent:2em;display:block;">我们收集个人信息的主要目的是令我们能为您提供安全和有效的服务，同时不断改良我们的服务和功能，以满足您的需求。我们收集的个人信息仅和这些目的相关。</span>
                <h6>3、收集个人信息的方式</h6>
                <span style="text-indent:2em;display:block;">我们通过您向我们提供资讯、或借助网络技术来收集个人信息。</span>
                <h6>4、接受与退出的选择权</h6>
                <span style="text-indent:2em;display:block;">只有当您同意与我们联系时，我们才会与您联络。当您选择接收电子邮件时，我们可能会定期向您发送推广活动资讯的电子邮件。您只须按照邮件中的操作指示或直接回复邮件，便可随时选择停止接收此类电子邮件。</span>
                <h6>5、更新或删除您的个人信息</h6>
                <span style="text-indent:2em;display:block;">请您了解并同意，对于您提供的所有个人信息，除非您删除或者通过系统设置拒绝我们收集，否则将被视为在您使用我们的产品与/或服务期间持续授权同意我们使用。当您有意修改或删除个人信息的要求，我们将按您的要求作出变更。</span>
                <h6>6、信息分享</h6>
                <span>6.1未经您同意，我们不会与任何第三方分享您的个人信息，但我们可能将您的个人信息与第三方合作伙伴分享，用作下列用途：</span>
                <span>6.1.1 向您提供我们的产品与/或服务。</span>
                <span>6.1.2维护和改善我们的产品与/或服务。</span>
                <span>6.2 基于以上用途，您授权我们可以把您的信息发送给第三方。如我们与任何第三方分享您的个人信息，我们将努力确保该第三方在使用您的个人信息时遵守本隐私保护政策及我们要求其遵守的其他适当的保密和安全措施。</span>
                <span>6.3 随着我们业务的持续发展，我们以及我们的关联公司可能进行合并、收购、资产转让或类似交易，您的个人信息可能作为此类交易的一部分而被转移，我们将在转移前通知您。</span>
                <h6>7、未成年人隐私权的保护</h6>
                <span style="text-indent:2em;display:block;">7.1我们将建立和维持一合理的程序，以保护未成年人个人信息的保密性及安全性。任何18周岁以下的未成年人参加网上活动应事先征得家长或其法定监护人的同意。</span>
                <span style="text-indent:2em;display:block;">7.2 未经监护人之同意，我们将不会使用未成年人的个人信息，亦不会向任何第三方披露或传送可识别该未成年人的个人信息。我们如收集监护人或未成年人的姓名或其它网络通讯资料之目的仅是为获得监护人同意，则在经过一段合理时间仍未获得同意时，将主动从记录中删除此类资料。</span>
                <h6>8、确保您的个人信息安全</h6>
                <span style="text-indent:2em;display:block;">我们非常重视您个人信息的安全，并致力保护我们所收集的资料。我们采用严密的安全措施和先进的设备，以确保收集的客户资料不会遗失、被误用或更改。然而互联网并非绝对安全的环境，或任何无线网络上的资料传输都不能保证百分百安全，一旦发生个人信息安全事件，我们将按照法律法规的要求，及时向您告知。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况</span>
                <h6>9、个人信息之披露</h6>
                <span style="text-indent:2em;display:block;">我们非常重视您对我们的信赖，因此绝不会向他人出售、出租或泄露您的个人信息，但我们可能基于以下目的披露您的个人信息：</span>
                <span>（a）为了遵循法律或执行司法程序；</span>
                <span>（b）为了保护我们的合法权利或财产，保护我们的用户；</span>
                <span>（c）为了调查、避免或处理违法行为、可疑诈骗、可能威胁人身安全的情形。</span>
                <h6>10、免责</h6>
                <span style="text-indent:2em;display:block;">任何由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而造成的个人信息泄露、丢失、被盗用或被窜改等，在此种情况下，我们均得免责。</span>
                <h6>11、接受本隐私保护政策</h6>
                <span style="text-indent:2em;display:block;">当您向我们提供信息时，即表示您已接受本隐私保护政策的条款和条件，我们有权按照本政策所说明的方式使用您的资讯。我们可能适时修订本政策内容，如您继续使用我们的服务，即表示同意受经修订的政策约束。</span>
            </div>
            <!--            <span slot="footer" class="dialog-footer">-->
            <!--    <el-button @click="show_alert = false">取 消</el-button>-->
            <!--    <el-button type="primary" @click="show_alert = false">确 定</el-button>-->
        </el-dialog>
    </div>

</template>

<script>
    // import store from '@/store'
    // import crypto from 'crypto';
    // import { setTimeout } from 'timers';
    import src_err from '@/assets/img/err.png'
    import src_null from '@/assets/img/null.png'

    import src_custom from '@/assets/img/custom_name.png'
    import address from '@/assets/img/address.png'
    import share_phone from '@/assets/img/share_phone.png'

    export default {
        name: 'share',
        data() {
            var checkPhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号不能为空'));
                } else {
                    const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/
                    console.log(reg.test(value));
                    if (reg.test(value)) {
                        callback();
                    } else {
                        return callback(new Error('请输入正确的手机号'));
                    }
                }
            };
            return {
                src: {
                    src_err,
                    src_null,
                    src_custom, address, share_phone
                },
                length: '',
                // 大图
                bigImage: '',
                // 是否加载
                isReload: true,
                // 商品详情
                product_info: {},
                // 商品数量
                num: 1,
                htmlstr: [],
                show_alert: false,
                ruleForm: {
                    name: '',
                    phone: '',
                    address: '',
                    resource:''
                },
                ruleForm1: {
                    name: '',
                    phone: '',
                    address: '',
                    resource: ''
                },
                rules: {
                    name: [
                        {required: true, message: '请输入姓名', trigger: 'blur'},
                    ],
                    phone: [
                        {required: true, message: '请输入正确的手机号', validator: checkPhone, trigger: 'blur'},

                    ],
                    // resource: [
                    //     {required: true, message: '请选择', trigger: 'blur'},
                    // ],
                },
                share_custom_info: {},
                share_hash:'',
                product_hash:'',
            }
        },
        methods: {
            showAlertAction() {
                this.show_alert = true;
            },
            submitForm(formName) {
                if (this.share_hash){
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            console.log(this.ruleForm.name,this.ruleForm.phone,this.ruleForm.resource)

                            this.$http({
                                url:'custom_submit',
                                data:{
                                    name:  this.ruleForm.name,
                                    phone: this.ruleForm.phone,
                                    zhuangshi: this.ruleForm.resource,
                                    share_hash: this.share_hash
                                }
                            }).then((res)=>{
                                console.log(res.data)

                                this.ruleForm.name = ''
                                this.ruleForm.phone = ''
                                this.ruleForm.resource = ''
                                this.$message({
                                    message: '提交成功',
                                    type: 'success'
                                });
                            }).catch((err)=>{
                                console.log(err)
                            })

                        } else {
                            return false;
                        }
                    });
                }

            },
            submitForm1(formName) {
                if (this.share_hash) {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            console.log(this.ruleForm1.name, this.ruleForm1.phone, this.ruleForm1.resource)

                            this.$http({
                                url:'custom_submit',
                                data:{
                                    name:  this.ruleForm1.name,
                                    phone: this.ruleForm1.phone,
                                    zhuangshi: this.ruleForm1.resource,
                                    share_hash: this.share_hash
                                }
                            }).then((res)=>{
                                console.log(res.data)

                                this.ruleForm1.name = ''
                                this.ruleForm1.phone = ''
                                this.ruleForm1.resource = ''
                                this.$message({
                                    message: '提交成功',
                                    type: 'success'
                                });
                            }).catch((err)=>{
                                console.log(err)
                            })

                        } else {
                            return false;
                        }
                    });
                }

            },
            handleClose() {
                this.show_alert = false;
            },
            login() {
                this.$http({
                    url: 'login',
                    data: {
                        company_yu: 'STDQ',
                        username: '15079672483',
                        password: 'b3df5b809684c0755283e8e4f59de995',
                    },
                }).then(res => {
                    if (res.code == 1) {
                        // this.$message({
                        //     message:`${res.msg}`,
                        //     type: 'success'
                        // });
                        this.$store.commit({
                            type: 'set_userInfo',
                            data: res.data
                        })
                        console.log('login success');
                        // this.getProductDetail('5e4b65acfe8273b3c729a1480c72b46f');
                        this.getProductDetail(this.$route.query.product_hash);
                    }
                }).catch((err) => {
                    this.isLoading = false
                    console.log(err)
                });
            },

            getProductDetail(product_hash) {
                this.$http({
                    url: 'product_detail',
                    data: {
                        product_hash: product_hash,
                        share_hash: this.share_hash
                    }
                }).then((res) => {
                    this.isReload = false;
                    // console.log('res', res.data.product_img_url);
                    if (res.code == 1) {
                        this.product_info = res.data.product_info
                        this.length = res.data.product_info.product_img_url.length
                        // console.log(this.product_info);
                        // console.log(this.length);

                        if (res.data.product_info.product_img_url.length > 0) {
                            this.bigImage = res.data.product_info.product_img_url[0]
                        }
                        this.share_custom_info = res.data.product_info.share_custom_info;
                        // 处理图片字符串
                        if (res.data.product_info.product_external_img.length > 0) {
                            let arr = res.data.product_info.product_external_img.match(/src="([^"]*?)"/ig)
                            for (let i in arr) {
                                arr[i] = arr[i].replace(/(src=")|(")/ig, '')
                                this.htmlstr = arr
                                // console.log(arr);
                            }
                        }


                    }
                }).catch((err) => {
                    console.log(err)
                })
            }
        },
        created() {
            const {share_hash, product_hash,} = this.$route.query
            this.share_hash = share_hash;
            // TODO
            // this.share_hash = '8e5dc5cb466a0476fe5a6f1380a77f82'
            this.product_hash = product_hash
            // console.log(this.$route.query.product_hash);
            this.login();
            // console.log(store.getters.get_userInfo['utoken']);
        },
        mounted() {
            // console.log("share");
            // this.getProductDetail('8dd767ea25387d06d06084ebd7935584');
        }
    }
</script>
<style lang="scss">
    .share-form {
        padding: 16px 16px 0px 16px;
        .el-form-item {
            margin-bottom: 10px;
        }

        /*.el-form--label-top .el-form-item__label{*/
        /*    padding-bottom: 0px;*/
        /*    }*/

        .el-form-item .el-form-item__content {
            margin-top: -10px;
        }

        .el-form-item .el-form-item__label {
            height: 40px;
            font-size: 15px;
        }

        .el-form-item .el-input__inner {
            /*width: 220px;*/
            border-top-width: 0px;
            border-left-width: 0px;
            border-right-width: 0px;
            border-bottom-width: 1px;
            border-radius: 0px;
            padding: 0;
            margin-left: 10px;
            margin-right: 10px;
            max-width: 95%;
            background: transparent;
        }

        .el-form-item .el-radio-group {
            padding-left: 10px;
            padding-right: 10px;
        }
    }

</style>
<style lang="scss" scoped>
    .border-info {
        border-width: 1px;
        border-color: #17512b;
        border-style: solid;
        font-size: 13px;
        color: #333333;
        padding: 13px;
        margin-top: 20px;
        margin-bottom: 10px;
    }


    // 商品图片与操作
    .product_operating {
        // width:1200px;
        margin: 0 auto;
        // padding-bottom:100px;
    }

    .product_operating_nav {
        padding: 40px 0 30px;
    }

    .box_operation {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
    }

    .show_image > ul {
        display: flex;
        align-items: center;
        // margin-top:40px;
        width: 100%;
        height: 80px;
        position: relative;

        li:first-child, li:last-child {
            // width:40px;
            height: 40px;
            border-radius: 50%;
            line-height: 40px;
            text-align: center;
            color: #D4D4D4;
            // border:1px solid #D4D4D4;
            cursor: pointer;
            z-index: 2;
            opacity: 1;

            i {
                font-size: 22px;
            }
        }

        li:first-child {
            position: absolute;
            left: 0;
            top: 20;
        }

        li:last-child {
            position: absolute;
            right: 0;
            top: 20;
        }

        li:first-child:hover, li:last-child:hover {
            opacity: 1;
            animation: hover_in 1s linear 1;
        }

        li:nth-child(2) {
            width: 380px;
            height: 80px;
            margin: 0 40px;
            overflow: hidden;
            position: relative;
            z-index: 0;

            > div {
                display: flex;
                position: absolute;
                left: 0;
                top: 0;
                z-index: 1;
            }
        }
    }

    @keyframes hover_in {
        0% {
            opacity: 0;
        }
        20% {
            opacity: .8;
        }
        40% {
            opacity: .2;
        }
        60% {
            opacity: .5;
        }
        80% {
            opacity: .9;
        }
        100% {
            opacity: 1;
        }
    }

    .operation {
        width: auto;
    }

    .operation > li:nth-child(1) {
        border-bottom: 1px solid rgb(219, 206, 206);

        h3 {
            font-weight: 500;
            font-size: 30px;
            line-height: 30px;
        }

        p {
            padding: 20px 0;
            line-height: 25px;
        }
    }

    .operation > li:nth-child(2) {
        border-bottom: 1px solid #D4D4D4;
    }

    .operation > li:nth-child(3) {
        p {
            padding: 20px 0;
        }

        ul {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 20px 0;

            li:nth-child(2), li:last-child {
                color: #BABDBF;
            }
        }
    }

    .operation > li:nth-child(4) {
        ul {
            display: flex;
            align-items: center;
            color: white;
            margin-top: 60px;

            li {
                justify-content: space-around;
                width: 220px;
                height: 50px;
                line-height: 50px;
                text-align: center;
                background: #FE9535;
                border-radius: 5px;
                font-size: 18px;
                font-weight: 500;
                cursor: pointer;
            }
        }
    }

    //商品详细信息
    .product_info {
        > div:first-child {
            background: #F7F7F7;
            padding: 16px 16px 16px 16px;

            > h3 {
                // width:1200px;
                // height:70px;
                // line-height:70px;
                margin: 0 auto;
                font-size: 120%;
            }
        }

        .img_list {
            > li {
                display: flex;
                justify-content: center;
                // width:1200px;
                margin: 0 auto;

                > div {
                    // width:790px;
                    display: flex;
                    justify-content: center;
                }
            }

            > li:last-child {
                margin-bottom: 40px;
            }
        }
    }
    .title-i{
        color:  #17512b;
    }
</style>
<style scoped>
    .show_image > ul >>> .el-image {
        display: block;
        margin: 0 10px;
    }

    .operation >>> .el-input-number {
        width: 220px;
    }

    .product_detail {
        box-sizing: border-box;
        padding-top: 0px;
        min-height: 100%;
    }

</style>
